/**
 * Per-tick input snapshot. This is the only input the simulation sees, and it
 * is what replays record. It contains *intent* (axes, buttons, view angles),
 * not interpretation: the motor decides what the input means.
 */
export interface InputFrame {
  /** Strafe axis, -1 (left) .. 1 (right). */
  moveX: number;
  /** Forward axis, -1 (back) .. 1 (forward). */
  moveZ: number;
  /** View yaw in radians. 0 looks toward -Z; positive turns left (counter-clockwise from above). */
  yaw: number;
  /** View pitch in radians, positive looks up. Not used by movement in Phase 1. */
  pitch: number;
  jumpHeld: boolean;
  /** True on the first tick after a jump key press (edge), even if released before the tick. */
  jumpPressed: boolean;
  /** Crouch / slide key held (Phase 8). The motor derives the press from the previous tick. */
  crouchHeld: boolean;
}

export const NEUTRAL_INPUT: Readonly<InputFrame> = Object.freeze({
  moveX: 0,
  moveZ: 0,
  yaw: 0,
  pitch: 0,
  jumpHeld: false,
  jumpPressed: false,
  crouchHeld: false,
});

export function makeInput(partial: Partial<InputFrame> = {}): InputFrame {
  return { ...NEUTRAL_INPUT, ...partial };
}

/** Recorded input for one simulation tick. Replays are arrays of these. */
export interface RecordedInput extends InputFrame {
  tick: number;
}
